var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-content',[_c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('ImportShipmentNoForm',{on:{"imported":_vm.showResult}}),_c('ImportShipmentNoResult',{ref:"ImportResult"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }